import { h } from 'preact';
import { useEffect, useRef } from 'preact/hooks';
import { USER_CLICK, USER_REPLAY } from '../../../../types';
import { TAP_LAYER } from '../../../common/constants';
import { useNewStore, usePlayerContext, useStyles } from '../../../common/hooks';
import { START_SCREEN_CONTAINER, START_SCREEN_PLAYBUTTON } from '../../../common/styles';
import { Delayed, withBreakPoints } from '../../hoc';
import { Button } from '../common';
import SpinnerFranceTV from '../spinner/spinner';
import {
  START_SCREEN,
  START_SCREEN_BUTTON_SIZE,
  START_SCREEN_BUTTON_SIZE_MINI,
  START_SCREEN_CONTAINER_HIDDEN
} from './styles';

function StartScreen({
  isMounted
}) {
  const { size } = useStyles()({
    'large+extraLarge': { size: START_SCREEN_BUTTON_SIZE },
    default: { size: START_SCREEN_BUTTON_SIZE_MINI }
  });
  const player = usePlayerContext();
  const { playButtonReady, showRestartButtonOnStartScreen } = useNewStore('ui', player);
  const { backgroundImage } = useNewStore('media', player);
  const startButtonRef = useRef();

  useEffect(() => {
    if (showRestartButtonOnStartScreen && startButtonRef.current) {
      startButtonRef.current.focus({ preventScroll: true });
    }
  }, [showRestartButtonOnStartScreen]);

  return (
    <Delayed
      isMounted={isMounted}
      shouldDelay
      delay={300}
    >
      {() => (
        <div
          className="ftv-start-screen"
          style={{
            ...START_SCREEN_CONTAINER,
            width: '100%',
            height: '100%',
            ...(!isMounted ? START_SCREEN_CONTAINER_HIDDEN : {}),
            zIndex: TAP_LAYER
          }}
        >
          <div
            className="ftv--magneto-startscreen"
            style={{
              ...START_SCREEN,
              width: '100%',
              height: '100%',
              backgroundImage: `url("${backgroundImage}")`,
              transform: 'scale(1.009)',
              backgroundSize: 'contain',
              backgroundRepeat: 'no-repeat'
            }}
          />
          <div style={START_SCREEN_PLAYBUTTON}>
            {!playButtonReady && <SpinnerFranceTV isMounted />}
            <Button
              type="icon"
              icon={showRestartButtonOnStartScreen ? 'replay' : 'play'}
              hidden={!playButtonReady}
              style={{
                pointerEvents: 'none'
              }}
              disableGlassEffect
              xl
              name="btn-first-play"
              disableFocus={false}
              ariaHidden="false"
              ariaLabel={showRestartButtonOnStartScreen ? 'Regarder à nouveau' : 'Lecture'}
              label={showRestartButtonOnStartScreen ? 'Regarder à nouveau' : 'Lecture'}
              forceLabel
              onClick={() => {
                if (showRestartButtonOnStartScreen) {
                  player.userEvents$.next({
                    action: USER_REPLAY,
                    source: USER_CLICK
                  });
                }
                player.play({ userGesture: true });
              }}
              iconRef={startButtonRef}
              disableCloseFocus
              size={size}
              enableBackground={false}
            />
          </div>
        </div>
      )}
    </Delayed>
  );
}

export default withBreakPoints(StartScreen);
